import BaseApi from "./BaseApi";

class CandidateOpportunityApi extends BaseApi {
  constructor() {
    super("candidate-opportunities");
  }

  getOpportunitySummariesByCompany(companyId, params) {
    return axios.get(`${this.baseUrl}/company/summaries`, { params: {company_id: companyId, ...params} });
  }

  getApplicationForm(opportunityUuid) {
    return axios.get(`${this.baseUrl}/${opportunityUuid}/application-form`);
  }
}

export default CandidateOpportunityApi;
